<template>
<div>
  <div :class="{'warning-icon':(!isMyUserAdmin)}" />
  <div :class="{'row':true,  'disabled-overlay':(!isMyUserAdmin)}">
    <div class="col-sm-10 col-md-4 col-lg-3">
      <div class="row mt-1 justify-content-center">
        <div class="col-12" ><DxButton text="create new bus/node" width="100%" type="success" @click="showAddBusNodeForm" /></div>
      </div>
      <div class="row mt-1">
        <DxTreeView  
          ref="deviceTree"
          :data-source="deviceTreeDS"
          data-structure="plain"
          selection-mode="single"
          caption="List"
          :select-by-click="true"
          @item-click="treeSelectionChange" >
           <template #item="item">
              <div class="row" style="height:15px">
                <p class="col">{{ item.data.text }}</p>
                <div class="col" style="max-width:40px;margin-top:-8px;margin-right:10px">
                  <DxButton
                    icon="trash"
                    type="danger"
                    stylingMode="text"
                    hint="Remove"
                    @click="showRemoveBusNodeVisible(item.data)"
                  />  
                </div>
              </div>
            </template>
        </DxTreeView>
      </div>
    </div>
    <div class="col-sm-12 col-md-8 col-lg-9">
      <div v-if="(devConfigView=='empty')" class="position-relative" style="height: 25vh; min-height: 100px;">
        <div class="position-absolute top-50 start-50 translate-middle">
          <h3 class="text-center">Select an item from the list to view and edit its configuration</h3>
        </div>
      </div>

      <!-- BUS CONFIG -->
      <div v-if="(devConfigView=='bus')">
        <div class="row mt-3 mb-4">
          <h3 class="col">Bus: {{ selectedBus }}</h3>
          <div class= "col-6 col-md-3">
            <DxButton
              text="Save changes"
              type="success"
              width="100%"
              @click="saveBusChanges"
            />  
          </div>
        </div>
         <DxForm :form-data="busConf"  label-location="left" :min-col-width="350">
          <DxGroupItem :col-count="2" :min-col-width="330">
            <DxSimpleItem data-field="name" editor-type="dxTextBox" :editor-options="{ maxLength: 50 }" />
            <DxSimpleItem data-field="uuid" editor-type="dxTextBox" :editor-options="{ maxLength: 50,disabled:true }" />
            <DxSimpleItem data-field="sectionId" editor-type="dxTextBox" :editor-options="{ maxLength: 50,disabled:true }" />
            <DxSimpleItem data-field="kVBase" editor-type="dxNumberBox" :editor-options="{ maxLength: 50 }" />
            <DxSimpleItem data-field="Meter" editor-type="dxSelectBox" :editor-options="{ maxLength: 50 }" /> <!-- TO DO -->
            <DxSimpleItem data-field="distFromMeter" editor-type="dxNumberBox" :editor-options="{ maxLength: 50 }" />
            
          </DxGroupItem>

          <DxGroupItem :col-count="2" :min-col-width="330" caption="Location">
            <DxSimpleItem data-field="lat" editor-type="dxNumberBox" :editor-options="{ maxLength: 50 }" />
            <DxSimpleItem data-field="long" editor-type="dxNumberBox" :editor-options="{ maxLength: 50 }" />
            <DxSimpleItem data-field="x" editor-type="dxNumberBox" :editor-options="{ maxLength: 50 }" />
            <DxSimpleItem data-field="y" editor-type="dxNumberBox" :editor-options="{ maxLength: 50 }" />
          </DxGroupItem>
        </DxForm>
      </div>

      <!-- NODES CONFIG -->
      <div  v-if="(devConfigView=='node')">
        <h3>Node: {{ selectedNode }}</h3>

        <div class="row">
          <div class="col mt-3">
            <h5>Activated components</h5>
            <div class="box">  
              <DxList
                :data-source="EnabledAssetsList"
                height="300"
                :show-selection-controls="true"
                selection-mode="multiple"
                v-model:selected-item-keys="SelectedItems"
              >
              </DxList>
            </div>
          </div>
          <div class="col-1 align-self-center " align="center">
            <div class="row-1  mb-4" >
              <DxButton
                id="back"
                icon="arrowright"
                @click="SelectAssetClick()"
              />
            </div>
            
          </div>
          <div class="col mt-3">
            <h5>Selected components</h5>
            <div class="box">
              <DxList
                :data-source="SelectedAssetsList"
                :repaint-changes-only="true"
                key-expr="id"
                height="300"
                :allow-item-deleting="true"
                item-delete-mode="toggle"
              >
                <DxItemDragging
                  data="doingTasks"
                  :allow-reordering="true"
                  :on-remove="onRemove"
                  group="tasks"
                />
              </DxList>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>

  

  <DxPopup
  content-template="add-bus-node-form"
  title="Add a New Bus / Node"
  max-width="300px"
  max-height="300px"
  :show-close-button="true"
  v-model:visible="isAddBusNodeVisible"
  :hide-on-outside-click="true">
  <template #add-bus-node-form>
    <DxForm :form-data="newBusNodeData"  label-location="left" >
      <DxSimpleItem 
        data-field="type" 
        :label="{text: 'New: '}" 
        editor-type="dxRadioGroup" 
        :editor-options="{ items:['bus','node'], layout:'horizontal'}"/>
      <DxSimpleItem 
        data-field="enfyoBuses_id" 
        :label="{text: 'Parent'}" 
        editor-type="dxSelectBox" 
        :editor-options="{dataSource:deviceTreeDS._items.filter(d=>d.type=='bus'),displayExpr:'text',valueExpr:'busId', disabled:(newBusNodeData.type=='bus')}"/> 
      <DxSimpleItem data-field="name" editor-type="dxTextBox">
        <DxRequiredRule message="Name is required" />
      </DxSimpleItem>
      <DxEmptyItem/>
      <DxGroupItem :col-count="2" :min-col-width="160" >
        <DxButtonItem :button-options="{ type:'danger', width: '100%', text: 'Cancel',  onClick: clearNewBusNodeConfig }" />
        <DxButtonItem :button-options="{ type:'success', width: '100%', text: 'Save',  onClick: saveNewBusNodeConfig}" />
      </DxGroupItem>
    </DxForm>
  </template>            
</DxPopup>


    <DxPopup
      content-template="confirm-delete-bus"
      :show-title="false"
      max-width="320px"
      max-height="100px"
      :show-close-button="false"
      v-model:visible="isRemoveBusNodeVisible"
      :hide-on-outside-click="false">
      <template #confirm-delete-bus>
        <p style="text-align: center;">Are you sure you want to delete this element?</p>
          <div class="row mt-1">
          <div class="col"><DxButton text="Yes" @click="deleteBusNode" type="normal" width="100%" height="30px" /></div>
          <div class="col"><DxButton text="No" @click="hideRemoveBusNodeVisible" type="danger" width="100%" height="30px"/></div>
        </div>
      </template>            
    </DxPopup>
    
<!--<DxPopup
  content-template="remove-bus-node-form"
  max-width="300px"
  max-height="300px"
  :show-close-button="true"
  v-model:visible="isRemoveBusNodeVisible"
  :hide-on-outside-click="true">
  <template #remove-bus-node-form>
    
    <DxButton  
      type='danger' 
      width= '100%' 
      text= 'Cancel'  
      onClick= clearNewBusNodeConfig />
    <DxButton  
      type='success' 
      width= '100%' 
      text= 'Save'  
      @click ="deleteBusNode()" />
      
  </template>            
</DxPopup>-->

</div>

</template>

<script>
import {ref,reactive} from 'vue';
import DxButton from 'devextreme-vue/button';
import { DxTreeView } from 'devextreme-vue/tree-view';
import CustomStore from "devextreme/data/custom_store";
import DataSource from "devextreme/data/data_source";
import notify from 'devextreme/ui/notify';
import RawDataService from '../services/RawDataServiceTemplate';
import {
  DxForm,
  DxSimpleItem,
  DxGroupItem,
  DxRequiredRule,
  DxButtonItem,
  DxEmptyItem
} from 'devextreme-vue/form';
import DxList, { DxItemDragging } from 'devextreme-vue/list';
import { DxPopup } from 'devextreme-vue/popup';
import { useStore } from 'vuex';

export default {
  components: {
    DxButton,
    DxTreeView,
    DxForm,
    DxSimpleItem,
    DxGroupItem,
    DxRequiredRule,
    DxButtonItem,
    DxEmptyItem,
    DxList,
    DxItemDragging,
    DxPopup
  },
  data(){
    
  },
  
  setup() {
    // Validate permissions
    const store = useStore()
    const DEF_AUTHCODES = { web:1, admon:100, iot:120 };
    const isMyUserAdmin = store.getters.hasAdminAccess(DEF_AUTHCODES.admon)
    //

    // GENERAL
    const stErrorCb = err => { notify(err.message, "error", 3000); }
    const mastersDataService = new RawDataService(`masters`);
    //const controllersDataService = new RawDataService(`controllers`);

    // TREE VIEW
    const devConfigView = ref('empty');
    const deviceTreeStore = new CustomStore({
      key: 'id',
      load: async() => {
        try{
          let newDs = [];
          const busesList = await mastersDataService.getByKey('buses');
          const nodesList = await mastersDataService.getByKey('nodes');
          for(const bus of busesList){
            const busNodes = nodesList.filter(s => s.enfyoBuses_id==bus.id);
            newDs.push({
              busId:bus.id,
              id: 'bus_'+bus.id,
              type: 'bus',
              text: bus.name, 
              expanded:true,
              uuid:bus.uuid })
            
            newDs = [
              ...newDs, 
              ...busNodes.map(nod => { return {
                nodeId:nod.id,
                id: 'node_'+nod.id, 
                type: 'node',
                text: nod.name, 
                parentId: 'bus_'+bus.id,
                uuid:nod.uuid
              } })
            ]
          }
          return newDs;
        }catch(err) { notify('error building buses tree: '+err.message, 'error', 4000); }
      }
    });

    const deviceTreeDS = new DataSource({
      store: deviceTreeStore,
      paginate: false
    });

    let selectedBus = ref(null);
    let selectedNode = ref(null);
    let selectedNodeId = ref(null);
    const treeSelectionChange = (e) => {
      const viewType = e.itemData?.type;
      selectedBus.value = null;
      selectedNode.value = null;
      switch (viewType) {
        case 'bus':
          selectedBus.value = e.itemData.text;
          break;
        case 'node':
          //selectedBus.value = e.itemData.parentId?.substring(4,e.itemData.parentId.length);
          selectedNode.value = e.itemData.text;
          selectedNodeId.value = e.itemData.nodeId;
          break;
      }
      devConfigView.value = viewType;
      loadbyId(e.itemData.uuid)
    }


    // New Bus / Node
    const busesDataService = new RawDataService(`masters/buses`);
    const nodesDataService = new RawDataService(`masters/nodes`);
    const newBusNodeData=reactive({
      type:'bus',
      name:'',
      enfyoBuses_id:null
    })
    const isAddBusNodeVisible = ref(false);
    const showAddBusNodeForm = () => { isAddBusNodeVisible.value=true; }
    const clearNewBusNodeConfig =() =>{
      isAddBusNodeVisible.value=false;
      newBusNodeData.type='bus';
      newBusNodeData.name='';
      newBusNodeData.enfyoBuses_id=null;
    }

    const saveNewBusNodeConfig =() =>{
      try{
        if(newBusNodeData.type=='bus'){
          busesDataService.create(newBusNodeData).then(res =>{
            if(res.affectedRows==1){
              isAddBusNodeVisible.value=false;
              notify(res.message||"Bus created", "success", 3500)
              deviceTreeDS.reload();
            }else{
              notify(res.message||"unexpected response", "warn", 3500)
            }
          })
        }
        else if(newBusNodeData.type=='node'){
          nodesDataService.create(newBusNodeData).then(res =>{
            if(res.affectedRows==1){
              isAddBusNodeVisible.value=false;
              notify(res.message||"Node created", "success", 3500)
              deviceTreeDS.reload();
            }else{
              notify(res.message||"unexpected response", "warn", 3500)
            }
          })
        }
      }catch(error){
        stErrorCb(error);
      }
    }

    let deletionObject=null;
    const isRemoveBusNodeVisible = ref(false);
    const showRemoveBusNodeVisible = (e)=>{
      deletionObject=e
      isRemoveBusNodeVisible.value = true;
    }
    const hideRemoveBusNodeVisible = ()=>{
        isRemoveBusNodeVisible.value = false;
    }
    const deleteBusNode = ()=>{
      try{
        hideRemoveBusNodeVisible()
        if(deletionObject.type=='bus'){
          for(var node of deviceTreeDS._items.filter((d=>d.parentId=='bus_'+deletionObject.busId))){
            nodesDataService.remove(node.uuid)
          }

          busesDataService.remove(deletionObject.uuid).then(res =>{
            if(res.affectedRows==1){
              //isAddBusNodeVisible.value=false;
              devConfigView.value = 'empty';
              notify(res.message||"Bus removed", "success", 3500)
              deviceTreeDS.reload();
            }else{
              notify(res.message||"unexpected response", "warn", 3500)
            }
          })
        }
        else if(deletionObject.type=='node'){
          nodesDataService.remove(deletionObject.uuid).then(res =>{
            if(res.affectedRows==1){
              //isAddBusNodeVisible.value=false;
              devConfigView.value = 'empty';
              selectedNodeId.value=null
              notify(res.message||"Node removed", "success", 3500)
              deviceTreeDS.reload();
            }else{
              notify(res.message||"unexpected response", "warn", 3500)
            }
          })
        }
      }catch(error){
        stErrorCb(error);
      }
    }

    // BUS CONFIG
    const busConf=reactive({
      name:'',
      uuid:'',
      sectionId:null,
      kVBase:null,
      distFromMeter:null,
      lat:null,
      long:null,
      x:null,
      y:null,
    })

    const loadbyId = async (uuid) =>{
      await mastersDataService.getByKey('buses/'+uuid).then(res => {
        Object.assign(busConf, res);
      }).catch(stErrorCb);

      EnabledAssetsList.reload();
      SelectedAssetsList.reload();
    }
  
    const saveBusChanges = () =>{
      mastersDataService.update('buses/'+busConf.uuid, busConf).then(res =>{
        if(res.isOk){
            notify(res.message||"Bus updated", "success", 3500)
            deviceTreeDS.reload()
          }else{
            notify(res.message||"unexpected response", "warn", 3500)
          }
      })
    }

    // NODE CONFIG

    const EnabledAssetsStore = new CustomStore({
      key: 'id',
    
      load: async() => {
        try{
         
          const newDs=[]
          let compList = await componentsDataService.getAll();
          compList = compList.filter(el => el.connection_id == null);
          
          compList.forEach((com)=>{
            if(com.type_component=='controller'){
              newDs.push({
                type:'controller',
                name: com.name,
                component_id: com.component_id,
                id: com.id,
                text:'controller - '+com.name
              })
            }else if(com.type_component=='asset'){
              newDs.push({
                type:'asset',
                name: com.name,
                component_id: com.component_id,
                id:com.id,
                text:'asset - '+com.name
              })
            }
            
          })
          
          return newDs;
        }catch(err) { notify('error : '+err.message, 'error', 4000); }  
          
      },  
    });

    const EnabledAssetsList = new DataSource({
      store: EnabledAssetsStore,
      paginate: false
    }); 

    //--

    const componentsDataService = new RawDataService('masters/components');
    const SelectedAssetsStore = new CustomStore({
      key: 'id',
    
      load: async() => {
        try{
          const newDs = [];
          
          if(selectedNodeId.value){
             let compList = await componentsDataService.getAll();
          
            let node_id = compList.find(el => el.component_id == selectedNodeId.value && el.type_component=='node').id
            compList = compList.filter(el => el.connection_id == node_id);
          
            compList.forEach((com)=>{
              if(com.type_component=='controller'){
                newDs.push({
                  type:'controller',
                  name: com.name,
                  component_id: com.component_id,
                  id: com.id,
                  text:'controller - '+com.name
                })
              }else if(com.type_component=='asset'){
                newDs.push({
                  type:'asset',
                  name: com.name,
                  component_id: com.component_id,
                  id:com.id,
                  text:'asset - '+com.name
                })
              }
              
            })
          }
          return newDs;
        }catch(err) { notify('error: '+err.message, 'error', 4000); }  
          
      },  
      insert: async (data) => {//data
        try{
          let node_id =  await componentsDataService.getByKey('node/'+selectedNodeId.value);
          await componentsDataService.update(data.id,{connection_id: node_id.id}).catch(er => console.log(er.message));
        }
        catch(error){ stErrorCb(error); }
        
      },
      remove: async(e) => {//e
        try{
          await componentsDataService.update(e,{connection_id: null}).catch(er => console.log(er.message));
          EnabledAssetsList.reload();
          SelectedAssetsList.reload();
          
        }catch(error){ stErrorCb(error); }
      
      },

    });

    const SelectedAssetsList = new DataSource({
      store: SelectedAssetsStore,
      paginate: false
    }); 

    const SelectedItems=ref([]);
    const SelectAssetClick = async()=>{
      try{
        for (const asset of SelectedItems.value){
           
          let assetobj = EnabledAssetsList._items.find(p => p.id==asset);
          SelectedAssetsList.store().insert({
            type: assetobj.type,
            id: assetobj.id,
            text: assetobj.text,
            name: assetobj.name,
            component_id: assetobj.component_id
          }).done(()=>{
            EnabledAssetsList.reload();
            SelectedAssetsList.reload();})
        }
        SelectedItems.value=[];

      }catch(error){ stErrorCb(error); }

    }


    return {
      isMyUserAdmin,
      devConfigView,
      selectedBus,
      selectedNode,
      deviceTreeDS,
      treeSelectionChange,
      showAddBusNodeForm,
      isAddBusNodeVisible,
      newBusNodeData,
      clearNewBusNodeConfig,
      saveNewBusNodeConfig,
      isRemoveBusNodeVisible,
      showRemoveBusNodeVisible,
      hideRemoveBusNodeVisible,
      deleteBusNode,

      busConf,
      saveBusChanges,
      EnabledAssetsList,
      SelectedItems,
      SelectedAssetsList,
      SelectAssetClick
    }
  },
}
</script>

<style>

.box{
  border-color: gray;
  border-width: 1px;
  border-style: dotted;
}

</style>
